import React, {useEffect, useState} from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, GetUrlParams, pathname} from "../../../components/Utils";
import {URL_FOR_RESOURCES} from "../../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {getAssociatedProducts, getProductBySlug, getProductOptions} from "./ProductDetailSlice";
import {RootState} from "../../../app/RootReducer";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import {
  buttonForWishlist,
  buttonHtmlAddItemToCart, buttonOfferRequest, buttonsQuantity,
  getFirstImageProduct, variantExistsInCart, productExistsInWishlist, orderItemFromCart
} from "../../../components/UtilsForCart";
import {
  ImageProduct,
  Product,
  ProductDetailOption,
  ProductDetailOptionValue,
  ProductVariant
} from "../../Entity/Product";
import Toaster from "../../../components/Toaster";
import useModal from "../../../components/Modal/UseModal";
import OfferModale from "../../Offer/OfferModale";
import {getItemInOfferCart, ResetAddSuccess} from "../../Offer/OfferCartSlice";
import {LocalParams} from "../../../components/LocalParams";
import PageTitle from "../../../components/PageTitle";
import slugify from "react-slugify";
import {useLocation, useNavigate} from "react-router-dom";
import {ProductsInCart} from "../../Entity/Cart";
import {selectAuthorizedProductIds, selectHidePrices} from "../../../components/Catalogue/userCatalogUtils";
import {getUserAccount, getUserCatalog} from "../../User/UsersSlice";
import ProductPrice from "../ProductPrice/ProductPrice";

const ProductItemDetail = () => {
  const locale = React.useMemo(() => GetCurrentLocale(), []);
  const dispatch = useDispatch();
  let history = useNavigate();
  const location = useLocation();

  const urlDetail = pathname.split("/");
  const slug = urlDetail[3];
  const token = LocalParams.getItem("token");

  useEffect(() => {
    changeLanguage(locale);
    dispatch(getProductBySlug(slug));
    dispatch(getProductOptions(slug, locale));
    if(isAuthenticated){
      dispatch(getUserAccount());
      if(token != null){
        dispatch(getUserCatalog(token))
      }
    }
  }, []);

  const userAccount = useSelector((state:RootState) => state.userRdc.userDetail?.customer)
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const product = useSelector((state:RootState) => state.productBySlugRdc.product);
  const productOptions = useSelector((state:RootState) => state.productBySlugRdc.productOptions);
  const isRequestingDetail = useSelector((state: RootState) => state.productBySlugRdc.isRequesting);
  const isRequestingOptions = useSelector((state: RootState) => state.productBySlugRdc.isRequestingOptions);
  const {isShowing, toggle} = useModal();

  const [showToaster, setShowToaster] = useState(false);
  const [isToasterForCart, setIsToasterForCart] = useState(false);

  const [num, setNum]= useState(0);
  const tokenCart = LocalParams.getItem('tokenCart') as string;
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart );
  const tokenOfferCart = LocalParams.getItem('tokenOfferCart') as string;
  const itemsInCartOffer = useSelector((state: RootState) => state.cartOfferRdc.offerCart);
  const nbItemInCartOffer = itemsInCartOffer && itemsInCartOffer.items.length > 0 ? itemsInCartOffer.items.length : 0;
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [isInCart, setIsInCart] = useState(false);
  const [variantSelected, setVariantSelected] = useState<ProductVariant|null>(null);
  const [optionsSelected, setOptionsSelected] = useState<{[index: string]: string}|null>(null);
  const [curOrderItem, setCurOrderItem] = useState<ProductsInCart|null>(null);

  const associatedProduct = useSelector((state:RootState) => state.productBySlugRdc.productsAssociated);
  const isRequestingAssociatedProduct = useSelector((state: RootState) => state.productBySlugRdc.isRequestingProductsAssociated);

  const isRequestingAddCart = useSelector((state:RootState) => state.cartRdc.isRequesting)
  const isRequestingRemoveCart = useSelector((state:RootState) => state.cartRdc.isRequestingDelete)
  const cardAddSuccess = useSelector((state:RootState) => state.cartRdc.isAddSuccess)
  const cartOfferAddSuccess = useSelector((state:RootState) => state.cartOfferRdc.isAddRequestSuccess)

  const metaDescription = product?.translations?.[locale]?.metaDescription || "";
  const metaKeywords = product?.translations?.[locale]?.metaKeywords || "";

  useEffect(() => {
      if(tokenOfferCart){
        dispatch(getItemInOfferCart(tokenOfferCart));
      }
    }, []
  );

  useEffect(() => {
    if(userAccount && product){
      if(productExistsInWishlist(product.id, userAccount.favouriteProducts)){
        setIsInWishlist(true);
      }
    }
    }, [userAccount, product]
  );

  useEffect(() => {
      if(tokenCart && product && itemsInCart && variantSelected){
        if(!isInCart && variantExistsInCart(variantSelected.code, itemsInCart.items)){
          setIsInCart(true);
          setCurOrderItem(orderItemFromCart(variantSelected.code, itemsInCart.items));
        }
        else if(isInCart && !variantExistsInCart(variantSelected.code, itemsInCart.items)){
          setIsInCart(false);
          setCurOrderItem(null);
        }
      }
    }, [itemsInCart, product, variantSelected]
  );

  useEffect(() => {
      if(product && !variantSelected){
        const defaultVariantCode = product.defaultVariant.code

        const urlVariantCode = GetUrlParams()["variant"];
        const urlVariant = product.variants.find(variant => variant.code === urlVariantCode) ?? null;

        const variant = product.variants.find(variant => variant.code === defaultVariantCode) ?? null;
        const selected = urlVariant ?? variant;

        if(selected)
        {
          history({search: "variant=" + selected.code});
          setVariantSelected(selected);
        }
      }
    }, [product]
  );

  useEffect(() => {
    if(product && productOptions && variantSelected && !optionsSelected)
    {
      let defaultOptions: {[index: string]: string} = {};

      productOptions.forEach(opt => {
        const existingValue = opt.optionValues.find(val => val.variantCodes.includes(variantSelected.code));

        if(existingValue)
        {
          defaultOptions[opt.optionName] = existingValue.optionValueName;
        }
      });

      setOptionsSelected(defaultOptions);
    }
  }, [product, productOptions, variantSelected]);

  function changeSelectedVariant(modifiedOption: ProductDetailOption, newOptionValue: ProductDetailOptionValue)
  {
    if(productOptions && product && optionsSelected)
    {
      let variantCodes: string[] = [];
      let newOptions: {[index: string]: string} = {};

      newOptions[modifiedOption.optionName] = newOptionValue.optionValueName;

      const notModifiedOptions = productOptions.filter(option => option.optionName !== modifiedOption.optionName);

      notModifiedOptions.forEach(notModifiedOption => {
        const selectedOption = notModifiedOption.optionValues.find(val => val.optionValueName === optionsSelected[notModifiedOption.optionName]);

        if(selectedOption)
        {
          newOptions[notModifiedOption.optionName] = selectedOption.optionValueName;
        }

        if(variantCodes.length === 0)
        {
          variantCodes = selectedOption ? selectedOption.variantCodes : [];
        }
        else
        {
          variantCodes = variantCodes.filter(code => selectedOption ? selectedOption.variantCodes.includes(code) : true);
        }
      });

      setOptionsSelected(newOptions);

      const newVariantCode = variantCodes.length > 0 ? variantCodes.find(code => newOptionValue.variantCodes.includes(code)) : newOptionValue.variantCodes[0];

      if(newVariantCode)
      {
        const variant = product.variants.find(variant => variant.code === newVariantCode);
        if(variant)
        {
          history({search: "variant=" + newVariantCode});
          setVariantSelected(variant);
        }
      }
      else
      {
        history(location.pathname, { replace: true });
        setVariantSelected(null);
      }
    }
  }
  let brandProduct: string|undefined = ""
  const [brandName, setBrandName] = useState("")

  useEffect(() => {
        if(product){
          dispatch(getAssociatedProducts(product.code, locale))
          brandProduct = product.brand.name;
          if (brandProduct !== undefined) {
            setBrandName(decodeURIComponent(brandProduct))
          }
        }
    }, [product]
  );

  // type Image or Document
  const getMediasProduct = (documentType: string) => {
    return(
      product && product.images.filter((a) => a.type === documentType).map((mediaItem: ImageProduct, index: number) => {
        return(
          documentType === "Image" ?
            <a
              href={URL_FOR_RESOURCES + mediaItem.path}
              data-lightbox="gallery-item" className="item-thumb" key={mediaItem.mediaName + "-" + index}>
              <img width="60" height="60" src={URL_FOR_RESOURCES + mediaItem.path} alt={product.name}/>
            </a>
            :
            <a href={URL_FOR_RESOURCES + mediaItem.path} className="input-group pb-2" target="_blank" key={mediaItem.mediaName}>
              <div className="alert alert-info-fiche alert-dashed d-flex align-items-center width100" key={mediaItem.mediaName}>
                  <i className="fa-solid fa-file-invoice mr-2"></i> Fiche technique
              </div>
            </a>
        )
      })
    )
  }

  const getAttributeValuesWithCode = (attributeValueEndCode: string, product: Product) => {
    return(
      product && product.attributeValues && Object.entries(product.attributeValues).map(([code, value]) => {
        if(code.includes(attributeValueEndCode) ){
          return <div dangerouslySetInnerHTML={{__html: value}} key={value + "-" + code}/>
        }else{
          return null
        }
        // return code.includes(attributeValueEndCode) ? <div dangerouslySetInnerHTML={{__html: value}} key={value}/> : null
      })
    )
  }
  const isProductAttributeIsNull = (array:any) => {
    return array.every((item:any)=> item === null);
  };

  const attributesCta = product && getAttributeValuesWithCode("_CTA_TEXT", product);
  const authorizedProductIds = useSelector(selectAuthorizedProductIds);
  const hidePrices = useSelector(selectHidePrices);

  // @ts-ignore
  const canSeeProduct = !authorizedProductIds || authorizedProductIds.includes(product?.id);
  const canSeePrice = canSeeProduct && !hidePrices;
  const canAddToCart = isAuthenticated && canSeeProduct;

  const addSuccess =  useSelector((state:RootState) => state.cartOfferRdc.isAddRequestSuccess)
  useEffect(() => {
    if (addSuccess) {
      setShowToaster(true);
      setIsToasterForCart(false);
      setTimeout(() => {
        dispatch(ResetAddSuccess());
      }, 1000);
    }
  }, [addSuccess]);

  return (
    isRequestingDetail ?
      <div className="container">
        <div className="row justify-content-center d-flex py-5 my-5">
          <SpinnerOnTop/>
        </div>
      </div>
      :
      product ?
        <>
          <PageTitle
            catalogueName={""}
            filters={null}
            productName={product.name}
            isforProductDetail={true}
            productmetaKeywords={metaKeywords}
            productmetaDescription={metaDescription}
          />
          <section className="padding-y bg-white shadow-sm" key={product.name}>
            <div className="container">
              <div className="row">

                <aside className="col-lg-3">
                  <article className="gallery-wrap">
                    <a href={getFirstImageProduct(product, true)} className="img-big-wrap img-thumbnail bg-light"
                       data-lightbox="gallery-item">
                      <img height="400" src={getFirstImageProduct(product, true)} className="mix-blend-multiply"
                           alt={product.name}/>
                    </a>
                    {/*<div className="thumbs-wrap mb-3" data-lightbox="gallery">*/}
                    {/*  {getMediasProduct("Image") }*/}
                    {/*</div>*/}
                  </article>
                </aside>
                <div className="col-lg-6 content-product-detail">
                  <article className="ps-lg-3">
                    <h4 className="title text-dark">{product.name}</h4>
                    <div className="price-wrap">
                      {
                        brandName ?
                          <strong className="price mr-2">{brandName}</strong>
                          :
                          null
                      }
                      {
                        variantSelected ?
                          <strong className="price-old break-word">{variantSelected.code}</strong>
                          : null
                      }
                    </div>
                    <hr/>
                    <div className="product-detail-description"
                         dangerouslySetInnerHTML={{__html: product.description}}
                    />
                    <div className="choice mb-5">
                      {
                        isRequestingOptions ?
                          <SpinnerOnTop/>
                          : productOptions && productOptions.length > 0 ?
                            productOptions.map((productOption, indexParent) => (
                              <article className="filter-group" key={productOption + "-" + indexParent}>
                                <header className="card-header">
                                  <a href="#" className="title collapsed" data-bs-toggle="collapse"
                                     data-bs-target={`#collapse_${slugify(productOption.optionName)}`}
                                     aria-expanded="false">
                                    <i className="control-icon-dropdown fa fa-chevron-down"/>{productOption.optionName}
                                  </a>
                                </header>
                                <div className="collapse" id={`collapse_${slugify(productOption.optionName)}`}>
                                  <div className="card-body">
                                    {
                                      productOption.optionValues.map((optionValue, index) => (
                                        <label className="checkbox-btn my-2"
                                               key={optionValue + "-" + index + "-" + indexParent}>
                                          <input type="checkbox"
                                                 checked={optionsSelected ? optionsSelected[productOption.optionName] === optionValue.optionValueName : false}
                                                 onChange={() => {
                                                 }}/>
                                          <span className="btn btn-light"
                                                onClick={() => changeSelectedVariant(productOption, optionValue)}>
                                          {optionValue.extraData && optionValue.extraData.firstColor ?
                                            <span className="color filter-square"
                                                  style={{backgroundImage: `linear-gradient(180deg, ${optionValue.extraData.firstColor}, ${optionValue.extraData.secondColor ?? optionValue.extraData.firstColor})`}}>
                                            </span>
                                            : null}
                                            {optionValue.optionValueName}
                                        </span>
                                        </label>
                                      ))
                                    }
                                  </div>
                                </div>
                              </article>
                            ))
                            : null
                      }
                    </div>
                  </article>
                </div>
                <aside className="col-lg-3">
                  {/* Affichage du tag taxon s’il existe */}
                  {product &&
                    product.taxons
                      .filter((a) => a.code === "location-entretien")
                      .map((taxonItem, index) => (
                        <div className="row mb-3" key={taxonItem.name + "-" + index}>
                          <div className="col-auto float-lg-end">
            <span className="tag mr-0 fs-14">
              <i className="me-2 text-success fa fa-check"></i>
              {taxonItem.name}
            </span>
                          </div>
                        </div>
                      ))}

                  {/* Documents du produit */}
                  {getMediasProduct("Document")}

                  {isAuthenticated && canSeeProduct ? (
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col mb-3">
                            {/* Prix visible uniquement si autorisé */}
                            {variantSelected && product && (
                              <ProductPrice
                                productItem={{ ...variantSelected, id: product.id }}
                                mode="detail"
                              />
                            )}
                            {/* Message si produit vendu par multiple */}
                            {variantSelected && variantSelected?.commercialUnit > 1 && (
                              <span className="alert alert-warning d-flex flex-column p-1 mb-0 mt-2">
                                <span className="fs-4">
                                  <i className="fa-solid fa-triangle-exclamation me-1"></i>
                                  Ce produit est vendu par {variantSelected.commercialUnit}
                                </span>
                                <small className="fs-10">
                                  Si vous prenez 2 quantités, vous en recevrez donc {variantSelected.commercialUnit * 2}
                                </small>
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Boutons quantité, wishlist, panier, offre */}
                        <div className="row gx-2 align-items-end">
                          {variantSelected && (
                            <>
                              <div className="col-md-8 mb-3">
                                <label className="form-label d-block">{t("quantity")}</label>
                                {buttonsQuantity(num, setNum)}
                              </div>

                              <div className="col-lg-4 col-sm-2 mb-3">
                                <div className="float-lg-end">
                                  {buttonForWishlist(
                                    !isInWishlist,
                                    dispatch,
                                    product.id,
                                    setIsInWishlist
                                  )}
                                </div>
                              </div>

                              <div className="col-md-12 col-sm-6 cart-button-product">
                                {!isRequestingAddCart || !isRequestingRemoveCart ? (
                                  buttonHtmlAddItemToCart(
                                    !isInCart,
                                    variantSelected.code,
                                    num,
                                    locale,
                                    dispatch,
                                    setShowToaster,
                                    setIsToasterForCart,
                                    cardAddSuccess,
                                    userAccount?.email ?? null,
                                    curOrderItem ? curOrderItem.id : undefined
                                  )
                                ) : (
                                  <SpinnerOnTop/>
                                )}

                                <div className="mt-5 position-relative">
                                  {product.isForOfferRequest && variantSelected && (
                                    buttonOfferRequest(
                                      variantSelected.code,
                                      num,
                                      locale,
                                      dispatch,
                                      nbItemInCartOffer,
                                      toggle,
                                      setShowToaster,
                                      cartOfferAddSuccess,
                                      userAccount?.email ?? null
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : canSeePrice ? (
                    // Bloc pour invité avec prix visible
                    <div className="card shadow-sm">
                      <div className="card-body bg-primary text-white bg-triangle text-center">
                        <h4 className="title text-center">{t('see_pricing')}</h4>
                        <p dangerouslySetInnerHTML={{__html: t('connect_or_create')}}/>
                      </div>
                    </div>
                  ) : null}
                </aside>
              </div>
            </div>
          </section>
          <OfferModale
            isShowing={isShowing}
            hide={toggle}
          />
          <Toaster showToaster={showToaster} setShowToaster={setShowToaster} isToasterForCart={isToasterForCart}
                   setIsToasterForCart={setIsToasterForCart}/>
        </>
        : <span>Product not found</span>
  )
}
export default ProductItemDetail;


